export function exitBRPTV() {

  // eslint-disable-next-line no-undef
  try {
    // eslint-disable-next-line no-undef
    const rendererService = new RendererService();
    rendererService.skip()
    return
  } catch(error) {
    console.error("[App] could not switch back to BRP tv using Render Service", error);
    
    fetch("http://localhost:8181/DeviceAdmin/svc/trigger?action=stop")
    .then((res) => res.json())
    .then(
      (result) => {
        console.log(result);
      },
      (error) => {
        console.error("[App] could not switch back to BRP tv", error);
      }
    );
  }
}


// WEBPACK FOOTER //
// ./src/services/BRPTV.js